<template>
  <div v-loading="loading">
    <div class="flow-sub-title">放款信息</div>
    <FundInfo ref="fundInfoRef" v-if="!loading" :permissions="permissions" :formValue="info" />
    <div class="flow-sub-title">账户信息</div>
    <AccountInfo
      ref="accountInfoRef"
      v-if="!loading"
      :permissions="permissions"
      :formValue="info"
    />
    <div class="flow-sub-title">批复信息</div>
    <ApproveInfo v-if="!loading" :permissions="permissions" :formValue="info" />
    <Contact :id="info?.loanId" :comType="comType" v-if="!loading" />
    <template v-for="item in positionsList" :key="item.title">
      <SubList v-if="!loading" :moduleData="item" :applyIds="applyIds" :comType="comType" />
    </template>
  </div>
</template>
<script lang="ts" setup>
import { getProduct, getSubTablebpm, getSubTableerp } from '@/apis/erp/income'
import SubList from './SubList.vue'
import FundInfo from './FundInfo.vue'
import AccountInfo from './AccountInfo.vue'
import ApproveInfo from './ApproveInfo.vue'
import { useSubTable } from './useSubTable'
import { getApproveInfo } from '@/apis/erp/loanManagement'
import { cloneDeep } from '@/utils/tools'
import Contact from './contact.vue'

const props = defineProps({
  id: String,
  formValue: {
    type: Object,
    default: () => ({})
  },
  permissions: {
    type: Object,
    default: () => ({})
  },
  tableCode: String,
  applyIds: {
    type: Object as PropType<{ id: string; productId?: string }>,
    default: () => ({})
  }
})

const loading = ref(true)
const info = ref<any>({}) // 提款申请审批DT
const fundInfoRef = ref()
const accountInfoRef = ref()

const comType = computed(() => {
  return props.tableCode === 'f455ff30babf4202aa570e7ab9a9ba91' ? 101 : 102
})

const { formatFieldConfig, positionsList } = useSubTable()

async function getDetails() {
  if (Object.keys(props.formValue).length > 0) {
    info.value = props.formValue
    // 展示子表数据
    await getSubTabledData(props.formValue.productId, props.formValue.intoPrimaryId)
    loading.value = false
  } else {
    try {
      const res = await getApproveInfo({ loanId: props.applyIds.id })
      info.value = res || props.formValue
      await getSubTabledData(res.productId, res.intId || res.intoPrimaryId)
    } catch (e) {
      info.value = props.formValue
    } finally {
      loading.value = false
    }
  }
}

async function getSubTabledData(productId: string, intId: string) {
  const positions = await getProduct({ productId: productId })
  let api = comType.value === 101 ? getSubTableerp : getSubTablebpm
  await formatFieldConfig(positions, intId, api)
}

onMounted(() => {
  getDetails()
})

async function handleSave() {
  const form1 = await fundInfoRef.value?.sure()
  const form2 = await accountInfoRef.value?.sure()
  let changeList: Recordable[] = []
  if (form1 && form2) {
    const newForm = Object.assign(form1, form2)
    let data = unref(props.formValue) || {}
    for (let key in newForm) {
      if (newForm[key] !== data[key]) {
        changeList.push({
          fieldSerial: key,
          oldValue: data[key],
          newValue: newForm[key]
        })
      }
    }
    return {
      changeList,
      data: Object.assign(cloneDeep(data), cloneDeep(newForm))
    }
  } else {
    return {
      errorMessage: '必填项未填写或填写错误'
    }
  }
}

defineExpose({
  handleSave
})
</script>
